export const goSingleStory = (slug, navigate) => {
	navigate(`/story/${slug}`);
};

export const onScroll = (page, setPage) => {
	if (document.body.offsetHeight - (window.innerHeight + window.scrollY) <= 100) {
		setPage(page + 1);
	}
};

export const storyImageLoaded = (setLoader, _storyImageLoad) => {
	_storyImageLoad.current += 1;
	if (_storyImageLoad.current === 1) {
		document.dispatchEvent(new Event('storyImagesLoaded', { bubbles: true }));
		setLoader(false);
	}
};

export const storyImageLoadedPodcast = (setLoader, _storyImageLoad) => {
	_storyImageLoad.current += 1;
	if (_storyImageLoad.current === 1) {
		document.dispatchEvent(new Event('storyImagesLoaded', { bubbles: true }));
		setLoader(false);
	}
};

export const goFrontPage = navigate => {
	navigate('/', { state: { reshuffle: Date.now() } });
};

export const shuffle = arr => {
	const a = [...arr];
	for (let i = a.length - 1; i > 0; i -= 1) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
};

export const openLink = () => {
	const win = window.open('https://www.ineverread.com/', '_blank');
	win.focus();
};

export const openShop = () => {
	const win = window.open('https://www.ineverread.shop/', '_blank');
	win.focus();
};

export const paginate = (array, pageNumber = 0) => (array ? array.slice(0, (pageNumber + 1) * 15) : []);

// Index-page batch loader.
// Phase 0: loads `firstBatch` items in parallel from t=0 (visible top fills fast).
// Phase 1+: advances by `batch` once each batch finishes loading.
export const computeCursor = (loadedCount, cap, firstBatch = 5, batch = 3) => {
	if (loadedCount < firstBatch) return Math.min(firstBatch - 1, cap);
	const extraBatches = Math.floor((loadedCount - firstBatch) / batch) + 1;
	return Math.min(firstBatch - 1 + extraBatches * batch, cap);
};

// Defensive dedupe — guard against the API ever returning duplicate stories.
export const dedupeStories = list => {
	const seen = new Set();
	return (list || []).filter(s => {
		const key = s?.uuid || s?.slug;
		if (!key || seen.has(key)) return false;
		seen.add(key);
		return true;
	});
};
